import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";
import { miscellaneous } from "../../data";

export function Miscellaneous() {
  return (
    <CategoryContainer title="Miscellaneous">
      <AutocompleteRHF
        name={"additionalInfo.miscellaneous"}
        options={miscellaneous}
        selectLabel={"Miscellaneous identifiers"}
        multiple={true}
      />
    </CategoryContainer>
  );
}
